import { AdvancedMarkerAnchorPoint } from "@vis.gl/react-google-maps";
import { AdvancedMarkerWithRef } from "./AdvancedMarker";
import { MarkerUI } from "./MarkerUI";

export const MapMarker = ({ data, entityType, onMouseEnter, currentPage = 1, pageSize = 10, useDriverIcon = false }) => {
  const coordinateKeyMap = {
    orders: "dest_coordinates",
  };

  // console.log(entityType, data);

  return (
    data &&
    data.map((item, idx) => {
      let latLong;

      // Check the entity type and extract coordinates accordingly
      if (entityType === "outlets") {
        const lat = parseFloat(item?.business_coordinatesX);
        const lng = parseFloat(item?.business_coordinatesY);

        if (!isNaN(lat) && !isNaN(lng)) {
          latLong = [lat, lng];
        }
      } else if (entityType === "drivers") {
        const lat = parseFloat(item?.coordinatesX);
        const lng = parseFloat(item?.coordinatesY);

        if (!isNaN(lat) && !isNaN(lng)) {
          latLong = [lat, lng];
        }
      } else if (entityType === "hubspots") {
        const lat = item?.lat;
        const lng = item?.lng;

        if (!isNaN(lat) && !isNaN(lng)) {
          latLong = [lat, lng];
        }
      } else {
        const coordinateKey = coordinateKeyMap[entityType];
        latLong = item?.[coordinateKey] ? item[coordinateKey].split(",") : null;
      }

      if (!latLong || latLong.length !== 2) return null;

      // Calculate driver number for drivers
      const driverNumber = entityType === "drivers" ? (item.driverNumber || idx + 1) : null;

      return (
        <AdvancedMarkerWithRef
          key={idx}
          position={{
            lat:
              entityType === "hubspots" ? latLong[0] : parseFloat(latLong[0]),
            lng:
              entityType === "hubspots" ? latLong[1] : parseFloat(latLong[1]),
          }}
          // clickable={true}
          anchorPoint={AdvancedMarkerAnchorPoint["BOTTOM"]}
          onMouseEnter={(marker) => {
            console.log("map marker", marker, item);

            onMouseEnter(
              item?.hotspot ? item.hotspot?._id : item?._id || item?.id,
              marker,
              entityType
            );
          }}
        >
          <MarkerUI entityType={entityType} driverNumber={driverNumber} useDriverIcon={useDriverIcon} />
        </AdvancedMarkerWithRef>
      );
    })
  );
};
